module.exports = "\n  <nav class=\"ot-footer navbar navbar-default\">\n        <ot-link-list class=\"navbar-bar navbar-left footer-left col-xs-12 ot-third-container\"></ot-link-list>\n        <ot-logo params=\"{type: 'footer'}\" class=\"navbar-bar navbar-left col-xs-6 ot-third-container\"></ot-logo>\n        <p ng-if=\"!vm.session.isOnward()\" class=\"ot-footer-contacts col-xs-6 ot-third-container\">{{\"FOOTER.QUESTIONS\" | translate}}<a href=\"mailto:debatenights2016@bbyo.org\">{{\"FOOTER.CONTACT_US\" | translate}}</a></p>\n\n  </nav>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/directives/navigation/footer.html
 ** module id = 283
 ** module chunks = 1
 **/